module.exports = __webpack_public_path__ + "static/media/marc.aba54d65.jpg";